<template>
  <div class="breadcrymb" v-if="!isTripartite">
    <Breadcrumb separator=">" class="breadcrumb">
      <Breadcrumb-item class="current">{{$t('Layout-BreadCrumbs0') || '当前位置'}}</Breadcrumb-item>
      <Breadcrumb-item v-for="item in levelList" :key="item.path" :to="item.path">{{$t(item.meta.title)}}</Breadcrumb-item>
    </Breadcrumb>
  </div>
</template>
<script>
export default {
  name: 'Navbar',
  data () {
    return {
      levelList: []
    }
  },
  watch: {
    $route () {
      this.getBreadcrumb()
    }
  },
  props: ['isTripartite'],
  created () {
    this.getBreadcrumb()
  },
  methods: {
    getBreadcrumb () {
      // $route.matched一个数组 包含当前路由的所有嵌套路径片段的路由记录
      // console.log(this.$route.matched)
      let matched = this.$route.matched.filter(item => item.name && item.meta.title)
      const first = matched[0];
      if (first && first.name.trim().toLocaleLowerCase() !== 'Dashboard'.toLocaleLowerCase()) {
        matched = [
          {
            path: '/open/default', meta: { title: window.i18n.t('Layout-BreadCrumbs1') }
          }
        ].concat(matched)
      }
      this.levelList = matched
    }
  }
}
</script>
<style scoped lang="less">
  .breadcrymb{
    line-height: 30px;
    padding: 9px 0;
  }
  .demo-breadcrumb-separator{
      color: #ff5500;
      padding: 0 5px;
  }
  .breadcrumb /deep/ .ivu-breadcrumb-item-link{
    font-weight: 400;
  }
  .current /deep/ .ivu-breadcrumb-item-link{
    color: #888;
  }
</style>
